module.exports = __webpack_public_path__ + "img/light-mud-decal-02.3ef48585.png";